import React from 'react';
import BannerSlider from "../components/Banner/BannerSlider";
import LatestNewsTransition from "../components/LatestNewsTransition";
import ServiceSection from "../components/ServicesSection.jsx";
import WhyChooseUs from "../components/WhyChooseUs";
import TeamSection from "../components/TeamSection.jsx";
import VideoSection from "../components/VideoSection";
import AboutSection from "../components/AboutSection.jsx";
import BlogSection from '../components/BlogSection.jsx';
import UniversityLocation from '../components/UniversityLocation.js';
import OpenAIChat from '../components/chatbot/OpenAIChat';
import UniversityInfo from '../pages/UniversityInfo.js';
import ScrollToTopButton from "../pages/ScrollToTopButton.jsx";
import CTASection from '../pages/CTASection.jsx';

const Home = () => {
  return (
 
     <div>
      <BannerSlider/>
      <LatestNewsTransition/>
	  
	     <div className="link-btn">
<a href="/events" className="theme-btn"
>
   <strong style={{ marginLeft: '20px' }}>All News and Events</strong>
</a>
        </div>
      <AboutSection/>      
      <VideoSection/>
      <ServiceSection/>
      <WhyChooseUs/>      
      <BlogSection/>
	   <CTASection/>
      <UniversityInfo/>
	  
	  <UniversityLocation/>	
	     <div>
     
    </div>
		

      <ScrollToTopButton/>
      
     </div>  
   
     
      
    
  
  )
}

export default Home